import { render } from "./SponsorEska.vue?vue&type=template&id=0628bf44"
import script from "./SponsorEska.vue?vue&type=script&lang=js"
export * from "./SponsorEska.vue?vue&type=script&lang=js"

import "./SponsorEska.vue?vue&type=style&index=0&id=0628bf44&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__